import React, { useCallback, useState } from 'react';
import CompareJobDetailModal from '@/components/myJob/modals/CompareJobDetailModal';

const useCompareJobV3DetailModal = ({ spaceId }) => {
  const [isOpen, setOpen] = useState(false);
  const [job, setJob] = useState({});

  return {
    show: useCallback(({ job }) => {
      setJob({ ...job });
      setOpen(true);
    }, []),
    Modal: useCallback(
      () =>
        isOpen ? (
          <CompareJobDetailModal spaceId={spaceId} job={job} onClose={() => setOpen(false)} />
        ) : null,
      [isOpen, spaceId, job]
    )
  };
};

export default useCompareJobV3DetailModal;
